/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit, signal} from '@angular/core';
import {UIRouter} from '@uirouter/core';
import * as _ from 'lodash';

import {OBJECT_TYPE} from '../../common/constants/object-type';
import {buildLastViewedEntries} from './simple-last-viewed.util';
import template from './creative-checker-page.component.html';
import {SIMPLE_PAGE_IMPORTS} from './simple-page-imports';
import {AdnTranslateService} from '../../common/filters/adn-translate.service';
import {AdnCheckerService} from '../../../components/util/adn-checker.service';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {LocalUserProfile} from '../../../components/session/local-user-profile';
import {NavigationHistoryService} from '../../../components/util/navigation-history.service';

@Component({
  standalone: true,
  imports: SIMPLE_PAGE_IMPORTS,
  selector: 'adn-creative-checker-page',
  template
})
export class CreativeCheckerPageComponent implements OnInit {
  lastViewed: any[] = [];
  lastViewedObject: any;
  selectFrom = 'CUSTOM';

  private readonly loadedState = signal(true);
  private readonly resultsState = signal<any[] | undefined>(undefined);
  get loaded(): boolean { return this.loadedState(); }
  set loaded(value: boolean) { this.loadedState.set(value); }
  get results(): any[] | undefined { return this.resultsState(); }
  set results(value: any[] | undefined) { this.resultsState.set(value); }
  objectId: string;
  objectType: any;
  objectTypes = OBJECT_TYPE;
  hashResults = true;
  forceRerun: boolean;
  ignoreScanHistory = '';

  constructor(
    @Inject(LocalUserProfile) localUserProfile: any,
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    @Inject(AdnCheckerService) private readonly adnChecker: any,
    private readonly adnTranslate: AdnTranslateService,
    private readonly uiRouter: UIRouter,
    navigationHistory: NavigationHistoryService
  ) {
    this.lastViewed = buildLastViewedEntries(localUserProfile, LocalNetworkProfile);
    this.lastViewedObject = _.get(this.lastViewed, [0]);
    this.objectId = navigationHistory.previousParams.id;
    this.objectType = _.find(_.values(OBJECT_TYPE), (ot) => ot.stateName === navigationHistory.previousState?.name);
  }

  get displayLoaded(): boolean {
    return this.loaded;
  }

  ngOnInit(): void {
    const creativeId = this.uiRouter.globals.params.creativeId;
    if (creativeId) {
      this.objectId = creativeId;
      this.doCheck();
    }
  }

  doCheck(): void {
    const id = this.selectFrom === 'LAST_VIEWED' ? this.lastViewedObject : this.objectId;
    this.loaded = false;
    this.adnChecker.checkId(id, this.forceRerun, this.hashResults, this.ignoreScanHistory === 'IGNORE').then((data: any) => {
      this.loaded = true;
      this.results = data.results;

      if (this.results[0]) {
        this.results[0].cookies = _.map(this.results[0].scan.cookies, (header: any) => {
          if (_.isString(header)) {
            const split = header.split(String.fromCharCode(31));
            return {
              name: split[0],
              value: split[1],
              expires: split[2],
              days: split[3]
            };
          }
          return header;
        });
      }
    });
  }

  translateViolation(violation: any): string {
    return this.adnTranslate.transform(violation.text, violation.code, violation.parameters);
  }

  scanNumber(index: number): number {
    return (this.results?.length || 0) - index;
  }
}
